import React from 'react';
import { connect } from 'react-redux';

import { startUpdateSegment } from '../../../actions/segment';
import CompoundSideListAddButton from '../../../components/compound/side/ListAddButton';
import { staticPermissions } from '../../../constants/authorization';
import { getMyPermissions } from '../../../reducers/analyticsApp';

const SegmentSideListAddButton = ({ tenantId, ...rest }) => (
  <CompoundSideListAddButton {...rest} path={`/${tenantId}/segments/add`} title="Add Segment" />
);

const mapStateToProps = (state, { tenantId }) => ({
  hasPermission: getMyPermissions(state).has(staticPermissions.SEGMENT_MANAGE),
  tenantId,
});

const mapDispatchToProps = {
  onAdd: startUpdateSegment,
};

export default connect(mapStateToProps, mapDispatchToProps)(SegmentSideListAddButton);
